// extracted by mini-css-extract-plugin
export default {"changePageWrapper":"styles_changePageWrapper__Fr1VZ","iconWrapper":"styles_iconWrapper__VJ0W7","rotate":"styles_rotate__mVChH","onRight":"styles_onRight__YtETD"};